import { useState } from "react";
import { PageHeader } from "../../../components/AthenaPricingEngine/page-header";
import { PowerBIEmbed } from "../../../components/AthenaPricingEngine/powerbi-embed";
import { SimulatorPanel } from "../../../components/AthenaPricingEngine/simulator-panel";
import { ToggleGroup, ToggleGroupItem } from "../../../ui/toggle-group";
import { usePowerBIReport } from "../lib/api/planning";

type Lens = "Simulator" | "Strategy";

export default function Planning() {
  const [lens, setLens] = useState<Lens>("Simulator");
  const powerBIQuery = usePowerBIReport();

  return (
    <div>
      <PageHeader title="Planning" subtitle="Simulate a scenario, or strategize across the book" />

      <div className="mt-8">
        <label className="flex flex-col gap-1.5">
          <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
            Lens
          </span>
          <ToggleGroup
            type="single"
            value={lens}
            onValueChange={(value) => value && setLens(value as Lens)}
            className="w-fit border border-border bg-secondary"
          >
            <ToggleGroupItem value="Simulator" className="h-9 px-4 text-sm">
              Simulator
            </ToggleGroupItem>
            <ToggleGroupItem value="Strategy" className="h-9 px-4 text-sm">
              Strategy
            </ToggleGroupItem>
          </ToggleGroup>
        </label>
      </div>

      {lens === "Simulator" ? (
        <SimulatorPanel />
      ) : (
        <div className="mt-6">
          <PowerBIEmbed
            productName="Pricing Strategy Report"
            src={powerBIQuery.data?.embedUrl}
            loading={powerBIQuery.isPending}
            height={640}
            emptyMessage="Power BI is not connected yet — set POWERBI_REPORT_URL to enable this report."
          />
        </div>
      )}
    </div>
  );
}
